import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    lang: '',
    platform: '',
    userId: '',
    sdkVersion: '',
    isAndroid: false,
    //
    Mrin: {},
    Printmaster: {},
    LabelMaster: {},
    XBManager: {},
    Phocol: {},
    /** Printmaster：APP 经 URL 传入的授权态；null 表示未传参，页面使用 JSON 默认 */
    printmasterAuth: null,
  },
  mutations: {
    updateData (state, data) {
      if (data instanceof Object) {
        Object.keys(data).forEach(key => {
          if (state.hasOwnProperty(key)) {
            state[key] = data[key]
          }
        })
      }
    }
  }
})